import { render } from "./ResetPassword.vue?vue&type=template&id=f513cf34"
import script from "./ResetPassword.vue?vue&type=script&lang=js"
export * from "./ResetPassword.vue?vue&type=script&lang=js"

const cssModules = {}
import style0 from "./ResetPassword.vue?vue&type=style&index=0&id=f513cf34&lang=scss&module=true"
cssModules["$style"] = style0

import exportComponent from "/home/circleci/project/times/vue/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__cssModules',cssModules]])

export default __exports__